'use strict';

class Rtf {
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                tables: this.wrap.querySelectorAll('table'),
                rtfVideos: this.wrap.querySelectorAll('iframe:not([src^="//www.123formbuilder.com/"], iframe:not([src^="//host.nxt.blackbaud.com"]), [src^="https://www.123formbuilder.com/"], [src^="//form.123formbuilder.com/"], [src^="https://form.123formbuilder.com/"], [src^="//radiomd.com/"], [src^="https://radiomd.com/"], [id^="trumba"], [id^="blackbaud"], [class^="blackbaud"])'),
                rtfOl: this.wrap.querySelectorAll('ol[start]')
            };

            if (this.ui.tables.length) {
                this.wrapTables();
            }

            if (this.ui.rtfVideos.length) {
                this.wrapRtfVideo();
            }

            if (this.ui.rtfOl.length) {
                this.resetCounter();
            }
        }
    }

    wrapTables() {
        for (var i = 0; i < this.ui.tables.length ; i++) {
            const table = this.ui.tables[i];

            table.outerHTML = [
                '<div class="table--responsive">',
                table.outerHTML,
                '</div>'
            ].join('');
        }
    }

    wrapRtfVideo() {
        let width,
            height,
            paddingBottom;

        for (let i = 0; i < this.ui.rtfVideos.length ; i++) {
            const video = this.ui.rtfVideos[i];
            const oncoreSrcRegex = /https:\/\/oncore/;

            width = video.getAttribute('width') || 853;
            height = video.getAttribute('height') || 480;

            if (oncoreSrcRegex.test(video.src)) {
                paddingBottom = '100%';
            } else {
                paddingBottom = ((height / width) * 100) + '%';
            }

            // video.outerHTML = [
            //     '<figure class="figure js-figure">',
            //     '<div class="figure__video js-figure-video" style="height: ' + height + 'px; padding-bottom: ' + paddingBottom + '">',
            //     video.outerHTML,
            //     '</div>',
            //     '</figure>',
            // ].join('');

            video.outerHTML = `
                <figure class="figure js-figure">
                    <div class="figure__video js-figure-video" style="height: ' + ${height} + 'px; padding-bottom: ' + ${paddingBottom} + '">
                        ${video.outerHTML}
                    </div>
                </figure>
            `;
        }
    }

    // allows users to reset ol counters in rtf fields using the start='' attribute
    resetCounter(){
        const orderedLists = document.querySelectorAll('ol[start]');

        for(let i = 0; i < orderedLists.length; i++) {
            let element = orderedLists[i];
            let startAttrVal = element.getAttribute('start');

            element.style.counterReset = `start ${startAttrVal - 1}`;
        }
    }
}

export default Rtf;
